// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2JjYS";
var _4 = "header-3QGwa";
var _5 = "icon-3-2gj";
var _6 = "content-1DszA";
var _7 = "title-PhBdq";
var _8 = "description-1xXT9";
var _9 = "line-2tkzX";
var _a = "footer-AOk0B";
var _b = "seatPrice-2AX1S";
var _c = "price-2WO0g";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "header", _5 as "icon", _6 as "content", _7 as "title", _8 as "description", _9 as "line", _a as "footer", _b as "seatPrice", _c as "price" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "header": _4, "icon": _5, "content": _6, "title": _7, "description": _8, "line": _9, "footer": _a, "seatPrice": _b, "price": _c }
